import DIApi from './_diApi';

class StatisticAPI extends DIApi {
  controllerName = 'Statistics';
}

export default new StatisticAPI();
